<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.pa-2.basic100
        v-row(no-gutters align="center")
          v-col.pa-3
            .h6.basic800--text(v-if="!isReadOnly") {{ $t('activate_yezza_pay') }}
            .h6.basic800--text(v-else) {{ $t('yezza_pay') }}

      v-divider.basic300

      v-card-text.px-2
        v-container.text-start(v-if="step == 1")
          v-card.px-4.elevation-0
            .account-type
              p.mb-2.label.basic600--text.text-uppercase {{ $t('bank_account_type') }}
              v-select(
                v-model='form.account_type'
                item-text="name"
                item-value="id"
                height="40"
                background-color="basic200"
                solo flat outlined dense persistent-hint
                :menu-props="{ bottom: true, offsetY: true }"
                :label="$t('account_type.label')"
                :placeholder="$t('account_type.placeholder')"
                :items="accountTypes"
              )
          div.p1.primary500--text.px-2
            div.p1.primary500--text.px-2 {{ $t('yezza_pay_rate') }}
            div.mt-4.p2.primary500--text.text-center {{ $t('yezza_pay_desc_1') }}
              br
              | {{ $t('yezza_pay_desc_2') }}

        v-form(v-else ref="form")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          v-card.pa-4.elevation-0(v-else-if="!isFetching")
            .stripe-onboard(v-if="form.active_fpx_provider === 'yezza_maybank'")
              v-alert(color="warning")
                div.caption {{ $t('section_partnering.desc_1') }}&nbsp;
                  a(href="https://stripe.com/en-my" target="_blank")
                    | Stripe
                    v-icon(x-small) mdi-open-in-new
                  |  {{ $t('section_partnering.desc_2') }}
                ul.pt-2
                  li.caption {{ $t('section_partnering.desc_3') }}
                  li.caption {{ $t('section_partnering.desc_4') }}
                div.caption.pt-2  {{ $t('section_partnering.desc_5') }}
                y-checkbox.ma-auto.mb-1.mt-3.agree-checkbox(v-model="stripeAgreed" :label="$t('agree_with_yezza_pay')" hide-details)
                v-btn.mt-4(color="primary" block depressed @click="migrateStripe" :loading="stripeDashboardLoading" :disabled="!stripeAgreed") {{ $t('activate_stripe') }}

            div(v-if="form.active_fpx_provider !== 'stripe'")
              .bank-details.mb-2(v-if="isReadOnly")
                div.caption {{ $t('bank.label') }}:
                  span.font-weight-bold  {{ selectedBank.name }}
                div.caption {{ $t('bank_acount.label') }}:
                  span.font-weight-bold  {{ form.bank_account }}
                div.caption {{ $t('account_name.label') }}:
                  span.font-weight-bold  {{ form.account_name }}
                div.caption {{ $t('account_type.label') }}:
                  span.font-weight-bold.text-capitalize  {{ form.account_type }}
                .ic(v-if="form.account_type == 'personal'")
                  div.caption {{ $t('ic.label') }}:
                    span.font-weight-bold  {{ form.ic }}
                .ssm(v-if="form.account_type == 'business'")
                  div.caption {{ $t('ssm.label') }}:
                    span.font-weight-bold  {{ form.ssm }}

              .bank-details-input(v-else)

                .bank-id
                  p.mb-1.label.basic600--text.text-uppercase {{ $t('bank') }}
                  v-select.mt-1(
                    v-model='form.bank'
                    solo flat outlined dense persistent-hint
                    item-color="white"
                    item-text="name"
                    item-value="id"
                    background-color="basic200"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :label="$t('bank.label')"
                    :placeholder="$t('bank.placeholder')"
                    :items="banks"
                    :rules="rules.selected"
                    :readonly="isReadOnly"
                  )
                    template(v-slot:selection="data")
                      v-row(align="center")
                        v-col.py-0.shrink
                          v-avatar(size="20")
                            v-img(:src="data.item.image")
                        v-col.pa-0
                          p.s1.mb-0.truncate-text {{ data.item.name }}
                    template(v-slot:item="data")
                      v-row(align="center")
                        v-col.py-2.shrink
                          v-avatar(size="40")
                            v-img(:src="data.item.image")
                        v-col.py-2
                          p.s1.mb-0 {{ data.item.name }}

                .bank-acount
                  p.mb-2.label.basic600--text.text-uppercase {{ $t('bank_acount.label') }}
                  v-text-field(
                    v-model="form.bank_account"
                    solo flat outlined dense persistent-hint
                    height="40"
                    background-color="basic200"
                    :label="$t('bank_acount.label')"
                    :placeholder="$t('bank_acount.placeholder')"
                    :rules="rules.account_valid"
                    :readonly="isReadOnly"
                  )

                .account-name
                  p.mb-2.label.basic600--text.text-uppercase {{ $t('account_name.label') }}
                  v-text-field(
                    v-model="form.account_name"
                    solo flat outlined dense persistent-hint
                    background-color="basic200"
                    height="40"
                    maxlength="40"
                    :label="$t('account_name.label')"
                    :placeholder="$t('account_name.placeholder')"
                    :rules="rules.name_valid"
                    :readonly="isReadOnly"
                  )

                .ic(v-if="form.account_type == 'personal'")
                  p.mb-2.label.basic600--text.text-uppercase {{ $t('ic.title') }}
                  v-text-field(
                    v-model='form.ic'
                    solo flat outlined dense persistent-hint
                    background-color="basic200"
                    height="40"
                    :label="$t('ic.label')"
                    :placeholder="$t('ic.placeholder')"
                    :rules="rules.ic_valid"
                    :readonly="isReadOnly"
                  )

                .ssm(v-if="form.account_type == 'business'")
                  p.mb-2.label.basic600--text.text-uppercase {{ $t('ssm.title') }}
                  v-text-field(
                    v-model='form.ssm'
                    solo flat outlined dense persistent-hint
                    height="40"
                    :label="$t('ssm.label')"
                    :placeholder="$t('ssm.placeholder')"
                    :rules="rules.ssm_valid"
                    :readonly="isReadOnly"
                  )

              .readonly.text-center(v-if="isReadOnly")
                div.font-weight-bold {{ $t('changing_above_details') }}
                div.caption {{ $t('changing_above_details_confirmation') }}
                v-btn.primary.my-2(rounded @click="sendEmail" small depressed).text-uppercase {{ $t('contact_support') }}
                v-divider.my-3

            .stripe-onboard(v-if="form.active_fpx_provider === 'stripe'")
              div {{ $t('yezza_pay_managed_by_stripe') }}
              v-layout.mt-3
                v-btn.primary(block depressed @click="viewStripeDashboard" :loading="stripeDashboardLoading") {{ $t('stripe_dashboard') }}
              v-divider.my-5


            .payment-cc(v-if="form.active_fpx_provider === 'stripe'")
              v-card.pa-2.px-4.mt-4(flat style="border:1px solid var(--v-basic300);")
                v-row
                  v-col
                    div.s2.basic700--text {{ $t('section_activate_card.title') }}
                    .c1.basic600--text - {{ $t('section_activate_card.desc_1') }}
                    .c1.basic600--text - {{ $t('section_activate_card.desc_2') }}
                    .c1.basic600--text - {{ $t('section_activate_card.desc_3') }}
                    .c1.basic600--text - {{ $t('section_activate_card.desc_4') }}
                  v-col.shrink
                    y-switch.ma-0.pa-0(v-model="form.card_enabled")

                .e-wallet
                  v-row
                    v-col
                      div.s2.basic700--text {{ $t('section_activate_grab_pay.title') }}
                      .c1.basic600--text - {{ $t('section_activate_grab_pay.desc_1') }}
                      .c1.basic600--text - {{ $t('section_activate_grab_pay.desc_2') }}
                    v-col.shrink
                      y-switch.ma-0.pa-0(v-model="form.grabpay_enabled")

                  //- v-row
                  //-   v-col
                  //-     div.s2.basic700--text Activate Ali pay
                  //-     .c1.basic600--text - 3% fee per transaction.
                  //-     .c1.basic600--text - Payout will be be transferred 3 days after transaction.
                  //-   v-col.shrink
                  //-     y-switch.ma-0.pa-0(v-model="form.alipay_enabled")

            .payment-notifications
              v-card.pa-2.px-4.mt-4(flat style="border:1px solid var(--v-basic300);")
                v-row
                  v-col
                    div.s2.basic700--text {{ $t('section_notify.title') }}
                    .c1.basic600--text {{ $t('section_notify.desc_1') }}
                  v-col.shrink
                    y-switch.ma-0.pa-0(v-model="form.send_sms")

            y-checkbox.mt-4(v-if="!isReadOnly" :rules="rules.agreedTerm" v-model="agree")
              template(v-slot:label)
                span
                  | {{ $t('i_agree_to') }} Yezza&nbsp;
                  a(@click.stop="" href="https://yezza.io/term-of-use/" target="_blank") {{ $t('terms') }}
                  | &nbsp;{{ $t('and') }}&nbsp;
                  a(@click.stop="" href="https://yezza.io/privacy-policy/" target="_blank") {{ $t('privacy_policy') }}

      v-divider
      v-card-actions(v-if="step != 0")
        v-spacer
        div(v-if="step == 2")
          v-btn.button-Aa-small(color='primary400', text @click='showModal = false')
            | {{ $t('cancel') }}
          v-btn.mr-2(color='info500' depressed height=32 :loading="isLoading" :disabled="!isReadOnly && !agree" @click='clickSave')
            div.button-AA-small.basic100--text {{ $t('save') }}
        div(v-else-if="step == 1")
          v-btn.button-Aa-small(color='primary400', text @click='showModal = false')
            | {{ $t('cancel') }}
          v-btn.mr-2(color='info500' depressed height=32 @click='clickNext' :loading="nextBtnLoading" :disabled="!form.account_type")
            div.button-AA-small.basic100--text {{ $t('next') }}
        div(v-else)
          v-btn.button-Aa-small(color='primary400', text @click='step = 1')
            | {{ $t('back') }}
          v-btn.mr-2(color='info500' depressed height=32 :loading="isLoading" @click='clickSave')
            div.button-AA-small.basic100--text {{ $t('activate') }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'UpdateYezzaPay',
  props: ['open', 'company'],
  data: (v) => ({
    isFetching: true,
    nextBtnLoading: false,
    stripeDashboardLoading: false,
    stripeAgreed: false,
    step: 0,
    isReadOnly: false,
    agree: false,
    form : {
      company: v.company.id,
      account_name: '',
      account_type: '',
      bank: '',
      bank_account: '',
      ic: '',
      ssm: '',
      send_sms: false,
      card_enabled: false,
      grabpay_enabled: false,
      alipay_enabled: false
    },
    personalToBusinessBankForm: {
      company: v.company.id,
      account_name: '',
      account_type: 'business',
      bank: '',
      bank_account: '',
      ssm: '',
      selected_fpx_provider: 'yezza_maybank'
    },
    selectedBank: null,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      selected: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
      agreedTerm: [
        v => !!v || 'You must agree with with Yezza Terms'
      ],
      name_valid: [val => (val || '').length > 0 || 'This field is required',
                   val =>  /^[a-zA-Z0-9&'(),-./_ @]*?$/.test(val) || 'Account name contains invalid characters'
      ],
      ssm_valid: [val => (val || '').length > 0 || 'This field is required',
                  val =>  /^[a-zA-Z0-9]*?$/.test(val) || 'SSM contains invalid characters'
      ],
      ic_valid: [val => (val || '').length > 0 || 'This field is required',
                  val =>  /^[a-zA-Z0-9]*?$/.test(val) || 'IC contains invalid characters'
      ],
      account_valid: [val => (val || '').length > 0 || 'This field is required',
                      val =>  /^[0-9]*?$/.test(val) || 'Bank account contains invalid characters'
      ],
    },
    banks: [
      { id: 'PHBMMYKL', name: 'Affin Bank Berhad', image: require('@/assets/images/fpx/ABB0233.png') },
      { id: 'BPMBMYKL', name: 'Agrobank / Bank Pertanian Malaysia Berhad', image: require('@/assets/images/fpx/AGRO01.png') },
      { id: 'MFBBMYKL', name: 'Alliance Bank Malaysia Berhad', image: require('@/assets/images/fpx/ABMB0212.png') },
      { id: 'RJHIMYKL', name: 'Al Rajhi Banking & Investment Corp. (M) Berhad', image: require('@/assets/images/fpx/RJHIMYKL.png') },
      { id: 'ARBKMYKL', name: 'AmBank (M) Berhad', image: require('@/assets/images/fpx/AMBB0209.png') },
      { id: 'BIMBMYKL', name: 'Bank Islam Malaysia Berhad', image: require('@/assets/images/fpx/BIMB0340.png') },
      { id: 'BKRMMYKL', name: 'Bank Rakyat Malaysia Berhad', image: require('@/assets/images/fpx/BKRM0602.png') },
      { id: 'BMMBMYKL', name: 'Bank Muamalat (M) Berhad', image: require('@/assets/images/fpx/BMMB0341.png') },
      { id: 'BSNAMYK1', name: 'Bank Simpanan Nasional Berhad', image: require('@/assets/images/fpx/BSN0601.png') },
      { id: 'CIBBMYKL', name: 'CIMB Bank Berhad', image: require('@/assets/images/fpx/BCBB0235.png') },
      { id: 'CITIMYKL', name: 'Citibank Berhad', image: require('@/assets/images/fpx/CITIMYKL.png') },
      { id: 'HLBBMYKL', name: 'Hong Leong Bank Berhad', image: require('@/assets/images/fpx/HLB0224.png') },
      { id: 'HBMBMYKL', name: 'HSBC Bank Malaysia Berhad', image: require('@/assets/images/fpx/HSBC0223.png') },
      { id: 'KFHOMYKL', name: 'Kuwait Finance House', image: require('@/assets/images/fpx/KFH0346.png') },
      { id: 'MBBEMYKL', name: 'Maybank / Malayan Banking Berhad', image: require('@/assets/images/fpx/MBB0228.png') },
      { id: 'AFBQMYKL', name: 'MBSB Bank Berhad', image: require('@/assets/images/fpx/AFBQMYKL.png') },
      { id: 'OCBCMYKL', name: 'OCBC Bank (M) Berhad', image: require('@/assets/images/fpx/OCBC0229.png') },
      { id: 'PBBEMYKL', name: 'Public Bank Berhad', image: require('@/assets/images/fpx/PBB0233.png') },
      { id: 'RHBBMYKL', name: 'RHB Bank Berhad', image: require('@/assets/images/fpx/RHB0218.png') },
      { id: 'SCBLMYKX', name: 'Standard Chartered Bank (M) Berhad', image: require('@/assets/images/fpx/SCB0216.png') },
      { id: 'UOVBMYKL', name: 'United Overseas Bank (M) Berhad', image: require('@/assets/images/fpx/UOB0226.png') }
    ],
    accountTypes: [
      {
        name: 'Business',
        id: 'business'
      },
     {
        name: 'Personal',
        id: 'personal'
      }
    ],
    existingPersonalMigrateAccountType: null
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapState('subscriptions', ['yezzaSubscription']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    showEwallet () {
      if (window.location.hostname.includes("localhost") || window.location.hostname.includes("arbatravel-test") || window.location.hostname.includes("tilawah")) {
        return true
      }
      return false
    }
  },
  created () {
    this.fetchSettings()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchSettings () {
      this.$axios.get(`/yezzapays/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length != 0) {
          this.form = response.data.results[0]
          if (!this.form.account_type) {
            if (this.form.ic) {
              this.form.account_type = 'personal'
            } else {
              this.form.account_type = 'business'
            }
          }
          this.selectedBank = this.banks.filter((bank) => {
            return bank.id == this.form.bank
          })[0]
          this.step = 2
          this.isReadOnly = true
        } else {
          this.step = 1
        }
        this.isFetching = false
      })
      .catch(() => {
        this.step = 1
      })
    },
    clickNext() {
      let stripeBusinessType = 'company'
      if (this.form.account_type === 'personal') {
        stripeBusinessType = 'individual'
      }
      this.nextBtnLoading = true
      let params = {
        company: this.company.id,
        business_type: stripeBusinessType,
      }
      if (this.$route.query.walkthrough) {
        params.redirect_url = location.protocol + '//' + location.host + '/admin/dashboard?walkthrough=true&from_stripe_onboard=true'
      }
      this.$axios.get('/yezzapays/onboard_stripe_link/', { params })
      .then(resp => {
        document.location.href = resp.data.url
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.nextBtnLoading = false
      })
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true

      // Migrate personal to business
      if (this.existingPersonalMigrateAccountType === 'business') {
        this.axios.put(`/yezzapays/${this.form.id}/`, this.personalToBusinessBankForm)
        .then(() => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.successfully_saved_bank_account')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      if (this.form.id) {
        if (this.form.ic) {
          this.form.ic = this.form.ic.match(/\d/g).join('')
        }
        this.axios.put(`/yezzapays/${this.form.id}/`, this.form)
          .then(() => {
            this.showModal = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
        return
      }
      this.axios.post(`/yezzapays/`, this.form)
        .then(() => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.request_under_processing')])
          this.$emit('activated', 'yezzapay')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    sendEmail() {
      window.open(`mailto:support@yezza.io?subject=Change bank details &body=Bank Name: %0D%0A Bank Account No: %0D%0A Account name: %0D%0A Account type: Personal/Business %0D%0A If Personal, IC number: %0D%0A If Business, Company SSM number: %0D%0A %0D%0A %0D%0A %0D%0A Company: ${window.location.href} %0D%0A %0D%0A Regards, %0D%0A ${this.member.user.first_name + ' ' + this.member.user.last_name}`, '_blank')
    },
    migrateStripe() {
      let stripeBusinessType = 'company'
      if (this.form.account_type === 'personal') {
        stripeBusinessType = 'individual'
      }
      this.stripeDashboardLoading = true
      let params = {
        company: this.company.id,
        business_type: stripeBusinessType,
        redirect_url: location.protocol + '//' + location.host + '/admin/settings/payment?from_stripe_onboard=true&existing_stripe_migration=true'
      }
      this.$axios.get(`/yezzapays/onboard_stripe_link/`, { params })
      .then(resp => {
        window.open(resp.data.url)
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.stripeDashboardLoading = false
      })
    },
    viewStripeDashboard() {
      this.stripeDashboardLoading = true
      this.$axios.get(`/yezzapays/${this.form.id}/get_stripe_link/?type=login`)
      .then(resp => {
        window.open(resp.data.url)
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.stripeDashboardLoading = false
      })
    }
  }
}
</script>

<style scoped>
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}

.truncate-text{
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.agree-checkbox >>> .v-input--selection-controls__input {
background: white;
}
</style>

<i18n>
{
  "en": {
    "activate_yezza_pay": "Activate Yezza Pay",
    "yezza_pay": "Yezza Pay",
    "bank": {
      "label": "Bank",
      "placeholder": "Select bank name"
    },
    "bank_acount": {
      "label": "Bank Account No",
      "placeholder": "Enter your bank account number"
    },
    "account_name": {
      "label": "Account name",
      "placeholder": "Enter the name of bank account owner"
    },
    "account_type": {
      "label": "Account type",
      "placeholder": "Select bank account type"
    },
    "ic": {
      "title": "Identity Card No.",
      "label": "IC number",
      "placeholder": "Enter your Malaysian identity card number"
    },
    "ssm": {
      "title": "Company Registration No.",
      "label": "Company SSM number",
      "placeholder": "E.g. 00123456X"
    },
    "bank_account_type": "Bank Account Type",
    "activate_stripe": "Activate Stripe",
    "bank": "Bank",
    "changing_above_details": "Changing above details?",
    "changing_above_details_confirmation": "Contact our support team and we’ll assist with your change.",
    "contact_support": "Contact support",
    "yezza_pay_rate": "RM1.50 + 0.25% flat rate fee for every transaction",
    "yezza_pay_desc_1": "Yezza Pay is provided by our partner, Stripe.",
    "yezza_pay_desc_2": "You will be redirected to Stripe onboarding page for the next step.",
    "yezza_pay_managed_by_stripe": "This Yezza Pay account is managed by Stripe. Go to Stripe dashboard to view payout status or update account information.",
    "stripe_dashboard": "Stripe Dashboard",
    "section_activate_card": {
      "title": "Activate Credit / Debit Card",
      "desc_1": "2.5% fee per transaction for Malaysia card.",
      "desc_2": "5% fee per transaction for international card.",
      "desc_3": "RM1,000 limit per transaction.",
      "desc_4": "Payout will be transferred 3 days after transaction."
    },
    "section_activate_grab_pay": {
      "title": "Activate Grab Pay",
      "desc_1": "3% fee per transaction.",
      "desc_2": "Payout will be transferred 3 days after transaction."
    },
    "section_notify": {
      "title": "Notify buyer upon payment",
      "desc_1": "Send receipt link through SMS (CHARGE: RM0.20/SMS)"
    },
    "i_agree_to": "I agree to",
    "terms": "Terms",
    "and": "and",
    "privacy_policy": "Privacy Policy",
    "section_partnering": {
      "desc_1": "We are partnering with",
      "desc_2": "to provide Yezza merchants with FPX and credit card payment capabilities.",
      "desc_3": "Special Stripe rate for Yezza merchants: RM1.50 + 0.25% per transaction.",
      "desc_4": "Payout will be transferred 3 days after transaction.",
      "desc_5": "All merchants using Yezza Pay are required to activate Stripe."
    },
    "agree_with_yezza_pay": "I agree with Yezza Pay - Stripe rate and payout terms"
  }
}
</i18n>
